var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoReport({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 25,
    viewBox: "0 0 26 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2292 2.41663C7.43316 2.41663 2.72916 7.12063 2.72916 12.9166C2.72916 18.7126 7.43316 23.4166 13.2292 23.4166C19.0252 23.4166 23.7292 18.7126 23.7292 12.9166C23.7292 7.12063 19.0252 2.41663 13.2292 2.41663ZM14.2792 18.1666H12.1792V16.0666H14.2792V18.1666ZM14.2792 13.9666H12.1792V7.66663H14.2792V13.9666Z",
    fill: "#573B76",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoReport);
export default __webpack_public_path__ + "static/media/info_report.5ea87b36068a5676a8ade4aa8312eeb8.svg";
export { ForwardRef as ReactComponent };